export enum ErrorKeys {
  NOT_FOUND_PROJECT = 'not_found_project',
  GENERAL_API_ERROR = 'general_api_error',
  PROJECT_MAX_DURATION_EXCEEDED = 'project_max_duration_exceeded',
  AI_VIDEO_GENERATION_FAILED = 'ai_video_generation_failed',
  AI_AVATAR_GENERATION_FAILED = 'ai_avatar_generation_failed',
  AI_IMAGE_GENERATION_FAILED = 'ai_image_generation_failed',
  AI_MODERATION_FAILED = 'ai_moderation_failed',
  AI_VIDEO_TEMPORARILY_UNAVAILABLE = 'ai_video_temporarily_unavailable',
  CUSTOM_API_ERROR = 'custom_api_error'
}
